"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUnifiedIconPath = exports.determineIconName = exports.getAppLogoFromLinkRecord = exports.getAppLogoFromUrl = exports.getAppLogoFromFilename = exports.getIconPath = exports.getActivityLogoFilePathInMode = exports.getLogoFilePathInMode = exports.getLogoFilePath = exports.getAppName = exports.getAppLogo = exports.getFileExtension = exports.getAppFromMimeType = exports.MIME_TYPE_MAPPINGS = exports.getAppFromUrl = exports.createCanonicalId = exports.parseExternalId = exports.findAppConfigById = exports.findLinkAppConfig = void 0;
const findLinkAppConfig = (url, allLinkAppConfig) => {
    const result = allLinkAppConfig.find((linkAppConfig) => {
        return linkAppConfig.matchKeys.some((matchKey) => {
            const allMatchKeys = matchKey.split("|");
            return allMatchKeys.every((match) => url.includes(match));
        });
    });
    return result ? result : (0, exports.findAppConfigById)("OTHER", allLinkAppConfig);
};
exports.findLinkAppConfig = findLinkAppConfig;
const findAppConfigById = (appId, allLinkAppConfigs) => {
    const result = allLinkAppConfigs.find((linkAppConfig) => {
        return (linkAppConfig === null || linkAppConfig === void 0 ? void 0 : linkAppConfig.id) && appId
            ? linkAppConfig.id.toLowerCase() === appId.toLowerCase()
            : false;
    });
    if (appId === "LINK_PDF") {
        console.log("[findAppConfigById] LINK_PDF lookup:", {
            found: !!result,
            logo: result === null || result === void 0 ? void 0 : result.logo,
            totalConfigs: allLinkAppConfigs.length,
            hasLinkPdf: allLinkAppConfigs.some((c) => c.id === "LINK_PDF"),
        });
    }
    return result;
};
exports.findAppConfigById = findAppConfigById;
const parseExternalId = (url, linkAppConfig) => {
    if (linkAppConfig.matchExternals.length === 0) {
        return;
    }
    if (linkAppConfig.id === "OTHER") {
        return url;
    }
    let result;
    for (const matchRegex of linkAppConfig.matchExternals) {
        const regex = new RegExp(matchRegex);
        const match = url.match(regex);
        if (match && match[1]) {
            console.log("found externalId", match[1]);
            if (!result) {
                result = match[1];
            }
            else {
                result = `${result}:${match[1]}`;
            }
        }
    }
    return result;
};
exports.parseExternalId = parseExternalId;
const createCanonicalId = (url, linkAppConfig) => {
    if (linkAppConfig.matchExternals.length === 0) {
        return linkAppConfig.id + ":" + url;
    }
    const externalId = (0, exports.parseExternalId)(url, linkAppConfig);
    if (!externalId) {
        return linkAppConfig.id + ":" + url;
    }
    return linkAppConfig.id + ":" + externalId;
};
exports.createCanonicalId = createCanonicalId;
const parseUrl = (url) => {
    try {
        return new URL(url);
    }
    catch (err) {
        console.warn(`[linkHelpers/parseUrl] Invalid URL format, trying with https://: ${url}`);
        try {
            // Prepend https:// and retry parsing
            return new URL(`https://${url}`);
        }
        catch (secondErr) {
            console.info(`[linkHelpers/parseUrl] ERROR parsing url ::${url}:: is not valid even after adding https://`);
            return;
        }
    }
};
const getAppFromUrl = (url, allLinkAppConfigs) => {
    const parsedUrl = parseUrl(url);
    if (!parsedUrl) {
        return "NOT_VALID_URL";
    }
    const resultAppConfig = (0, exports.findLinkAppConfig)(url, allLinkAppConfigs);
    if (resultAppConfig) {
        return resultAppConfig;
    }
    const otherApp = (0, exports.findAppConfigById)("OTHER", allLinkAppConfigs ? allLinkAppConfigs : []);
    console.log("[getAppFromUrl] otherApp", otherApp);
    return otherApp !== null && otherApp !== void 0 ? otherApp : "APP_CONFIG_NOT_FOUND";
};
exports.getAppFromUrl = getAppFromUrl;
/**
 * Consolidated MIME type to icon mapping
 * Used by both getAppFromMimeType and getAppLogoFromMimeType
 */
exports.MIME_TYPE_MAPPINGS = {
    // Google Apps
    "application/vnd.google-apps.document": {
        appId: "GOOGLE_DOC",
        icon: "google-docs-activity.svg",
    },
    "application/vnd.google-apps.spreadsheet": {
        appId: "GOOGLE_SPREADSHEET",
        icon: "google-sheets-activity.svg",
    },
    "application/vnd.google-apps.presentation": {
        appId: "GOOGLE_PRESENTATION",
        icon: "google-slides-activity.svg",
    },
    // Document formats
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": {
        appId: "GOOGLE_DOC",
        icon: "docx-logo.png",
    },
    "application/msword": {
        appId: "GOOGLE_DOC",
        icon: "docx-logo.png",
    },
    "application/pdf": {
        appId: "GOOGLE_DOC",
        icon: "pdf-logo.png",
    },
    "application/rdf": {
        appId: "GOOGLE_DOC",
        icon: "rdf-logo.png",
    },
    "application/txt": {
        appId: "GOOGLE_DOC",
        icon: "txt-logo.png",
    },
    "text/plain": {
        appId: "GOOGLE_DOC",
        icon: "txt-logo.png",
    },
    // Spreadsheet formats
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": {
        appId: "GOOGLE_DOC",
        icon: "excel-logo.png",
    },
    "application/vnd.ms-excel": {
        appId: "GOOGLE_DOC",
        icon: "excel-logo.png",
    },
    // Other platforms
    "ms/list-item": {
        appId: "MICROSOFT",
        icon: "aspxpage.svg",
    },
    "confluence/page": {
        appId: "CONFLUENCE",
        icon: "confluence.svg",
    },
    "application/vnd.confluence.page": {
        appId: "CONFLUENCE",
        icon: "confluence.svg",
    },
    "text/markdown": {
        appId: "MARKDOWN_FILE",
        icon: "markdown-activity.svg",
    },
};
const getAppFromMimeType = (mimeType, allLinkAppConfigs) => {
    const mapping = exports.MIME_TYPE_MAPPINGS[mimeType];
    if (mapping) {
        return (0, exports.findAppConfigById)(mapping.appId, allLinkAppConfigs);
    }
    console.log("[getAppFromMimeType] No mapping found for:", mimeType);
    return undefined;
};
exports.getAppFromMimeType = getAppFromMimeType;
const getFileExtension = (filename) => {
    return filename.toLowerCase().split(".").pop();
};
exports.getFileExtension = getFileExtension;
const getAppLogo = (appId, title, allLinkAppConfigs, ending) => {
    var _a;
    if (!appId) {
        return "other.svg";
    }
    console.log("[getAppLogo] Using unified determineIconName");
    const { iconName } = (_a = (0, exports.determineIconName)({
        linkRecord: {
            links: [{ appId, title: title || undefined }],
        },
    }, allLinkAppConfigs)) !== null && _a !== void 0 ? _a : { iconName: "other.svg", isActivity: false };
    // Apply ending if specified (for backward compatibility)
    if (ending && !iconName.endsWith(ending)) {
        const nameWithoutExtension = iconName.replace(/\.(svg|png)$/, "");
        return nameWithoutExtension + ending;
    }
    return iconName;
};
exports.getAppLogo = getAppLogo;
const getAppName = (appId, allLinkAppConfigs) => {
    if (!appId) {
        return "";
    }
    const index = allLinkAppConfigs.findIndex((linkApp) => {
        return (linkApp === null || linkApp === void 0 ? void 0 : linkApp.id) && appId
            ? linkApp.id.toLowerCase() === appId.toLowerCase()
            : false;
    });
    if (index !== -1) {
        return allLinkAppConfigs[index].displayName;
    }
    return "";
};
exports.getAppName = getAppName;
const getLogoFilePath = (logo, background = true) => {
    return (0, exports.getIconPath)(logo, {
        theme: "light-mode",
        background,
        isAppLogo: true,
    });
};
exports.getLogoFilePath = getLogoFilePath;
const getLogoFilePathInMode = (logo, background = true, theme = "light-mode") => {
    return (0, exports.getIconPath)(logo, { theme, background, isAppLogo: true });
};
exports.getLogoFilePathInMode = getLogoFilePathInMode;
const getActivityLogoFilePathInMode = (logo, theme = "light-mode") => {
    return (0, exports.getIconPath)(logo, { theme, isActivity: true, isAppLogo: true });
};
exports.getActivityLogoFilePathInMode = getActivityLogoFilePathInMode;
/**
 * Unified function to generate icon paths with consistent formatting
 * Replaces multiple inconsistent path generation functions
 */
const getIconPath = (iconName, options = {}) => {
    const { theme = "light-mode", background = true, isActivity = false, isAppLogo = true, customPath, } = options;
    // Handle custom paths (for non-standard icons)
    if (customPath) {
        return `/icons/${theme}/${customPath}`;
    }
    // Handle app logos
    if (isAppLogo) {
        const basePath = `/icons/${theme}/app_logos/`;
        if (isActivity) {
            // Activity logos don't have background suffix
            return basePath + iconName;
        }
        else {
            // Regular app logos with background/nobg suffix
            const suffix = background ? "-bg.svg" : "-nobg.svg";
            return basePath + iconName.replace(/\.(svg|png)$/, "") + suffix;
        }
    }
    // Handle general icons
    return `/icons/${theme}/${iconName}`;
};
exports.getIconPath = getIconPath;
const getAppLogoFromFilename = (filename) => {
    const extension = (0, exports.getFileExtension)(filename);
    console.log("[getAppLogoFromFilename] extension", extension);
    return extension + "-logo.png";
};
exports.getAppLogoFromFilename = getAppLogoFromFilename;
const getAppLogoFromUrl = (url, allLinkAppConfigs) => {
    try {
        const newLinkAppConfig = (0, exports.getAppFromUrl)(url, allLinkAppConfigs ? allLinkAppConfigs : []);
        if (newLinkAppConfig === "NOT_VALID_URL") {
            return undefined;
        }
        if (newLinkAppConfig === "APP_CONFIG_NOT_FOUND") {
            // (async () => {
            const otherApp = (0, exports.findAppConfigById)("OTHER", allLinkAppConfigs ? allLinkAppConfigs : []);
            if (otherApp) {
                return otherApp.logo;
            }
            // })();
        }
        else {
            return newLinkAppConfig.logo;
        }
    }
    catch (err) {
        console.log("[getAppLogoFromUrl] caugth error: ", err);
    }
    return undefined;
};
exports.getAppLogoFromUrl = getAppLogoFromUrl;
const getAppLogoFromLinkRecord = (linkRecord, allLinkAppConfigs, ending) => {
    console.log("[getAppLogoFromLinkRecord] Using unified determineIconName");
    const { iconName } = (0, exports.determineIconName)({ linkRecord }, allLinkAppConfigs);
    // Apply ending if specified (for backward compatibility)
    if (ending && !iconName.endsWith(ending)) {
        const nameWithoutExtension = iconName.replace(/\.(svg|png)$/, "");
        return nameWithoutExtension + ending;
    }
    return iconName;
};
exports.getAppLogoFromLinkRecord = getAppLogoFromLinkRecord;
/**
 * Unified function to determine icon name from various sources
 * Consolidates logic from getAppLogoFromLinkRecord, getAppLogo, and related functions
 */
const determineIconName = (source, allLinkAppConfigs) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    const { linkRecord } = source;
    const mimeType = linkRecord === null || linkRecord === void 0 ? void 0 : linkRecord.mimeType;
    const appId = ((_b = (_a = linkRecord === null || linkRecord === void 0 ? void 0 : linkRecord.links) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.appId) || "OTHER";
    const filename = (_d = (_c = linkRecord === null || linkRecord === void 0 ? void 0 : linkRecord.links) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.title;
    const url = (_f = (_e = linkRecord === null || linkRecord === void 0 ? void 0 : linkRecord.links) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.url;
    console.log("[determineIconName] DEBUG:", {
        appId,
        mimeType,
        filename,
        url: url === null || url === void 0 ? void 0 : url.substring(0, 100),
        linkRecordId: linkRecord === null || linkRecord === void 0 ? void 0 : linkRecord.id,
    });
    // Priority 0: PDF URL detection (fallback for records with wrong appId)
    if (url && appId === "OTHER") {
        const urlLower = url.toLowerCase();
        if (urlLower.includes(".pdf")) {
            console.log("[determineIconName] PDF URL detected with OTHER appId, overriding to use PDF icon");
            const pdfConfig = (0, exports.findAppConfigById)("LINK_PDF", allLinkAppConfigs);
            if (pdfConfig) {
                return { iconName: pdfConfig.logo, isActivity: false };
            }
        }
    }
    // Priority 1: MIME type (most definitive)
    if (linkRecord === null || linkRecord === void 0 ? void 0 : linkRecord.mimeType) {
        const mt = mimeType || (linkRecord === null || linkRecord === void 0 ? void 0 : linkRecord.mimeType);
        const mapping = exports.MIME_TYPE_MAPPINGS[mt];
        if (mapping) {
            // MIME type icons are activity format for Google apps and some special types
            const isActivity = mt.startsWith("application/vnd.google-apps") ||
                mt === "confluence/page" ||
                mt === "application/vnd.confluence.page" ||
                mt === "text/markdown";
            return { iconName: mapping.icon, isActivity };
        }
    }
    // Priority 2: Microsoft Drive special handling
    if ((linkRecord === null || linkRecord === void 0 ? void 0 : linkRecord.msDriveId) && ((_h = (_g = linkRecord.links) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.title)) {
        const extension = (0, exports.getFileExtension)(linkRecord.links[0].title);
        return { iconName: `${extension}-logo.png`, isActivity: false };
    }
    // Priority 3: Filename extension (for FILE appId or when filename provided)
    if ((appId === "FILE" || ((_k = (_j = linkRecord === null || linkRecord === void 0 ? void 0 : linkRecord.links) === null || _j === void 0 ? void 0 : _j[0]) === null || _k === void 0 ? void 0 : _k.appId) === "FILE") &&
        (filename || ((_m = (_l = linkRecord === null || linkRecord === void 0 ? void 0 : linkRecord.links) === null || _l === void 0 ? void 0 : _l[0]) === null || _m === void 0 ? void 0 : _m.title))) {
        const fn = filename || linkRecord.links[0].title;
        const extension = (0, exports.getFileExtension)(fn);
        return { iconName: `${extension}-logo.png`, isActivity: false };
    }
    // Priority 4: App ID from linkRecord or direct appId
    const finalAppId = appId || ((_p = (_o = linkRecord === null || linkRecord === void 0 ? void 0 : linkRecord.links) === null || _o === void 0 ? void 0 : _o[0]) === null || _p === void 0 ? void 0 : _p.appId);
    if (finalAppId) {
        console.log("[determineIconName] Looking up appConfig for appId:", finalAppId);
        const appConfig = (0, exports.findAppConfigById)(finalAppId, allLinkAppConfigs);
        if (appConfig) {
            console.log("[determineIconName] Found appConfig:", {
                id: appConfig.id,
                logo: appConfig.logo,
            });
            return { iconName: appConfig.logo, isActivity: false };
        }
        else {
            console.log("[determineIconName] No appConfig found for appId:", finalAppId);
        }
    }
    // Priority 5: URL-based determination
    if (url) {
        const appFromUrl = (0, exports.getAppFromUrl)(url, allLinkAppConfigs);
        if (typeof appFromUrl === "object" && appFromUrl.logo) {
            return { iconName: appFromUrl.logo, isActivity: false };
        }
    }
    // Fallback
    console.log("[determineIconName] Using fallback: other.svg");
    return { iconName: "other.svg", isActivity: false };
};
exports.determineIconName = determineIconName;
/**
 * Complete unified function that determines icon and generates full path
 * This is the main function that should be used by components
 */
const getUnifiedIconPath = (source, allLinkAppConfigs, options = {}) => {
    var _a, _b, _c;
    const { theme = "light-mode", background = true, forceActivity } = options;
    const { iconName, isActivity } = (0, exports.determineIconName)(source, allLinkAppConfigs);
    const finalPath = (0, exports.getIconPath)(iconName, {
        theme,
        background,
        isActivity: forceActivity !== undefined ? forceActivity : isActivity,
        isAppLogo: true,
    });
    console.log("[getUnifiedIconPath] Final path:", {
        iconName,
        isActivity,
        forceActivity,
        finalPath,
        appId: (_c = (_b = (_a = source.linkRecord) === null || _a === void 0 ? void 0 : _a.links) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.appId,
    });
    return finalPath;
};
exports.getUnifiedIconPath = getUnifiedIconPath;
